// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"6ba7a6aa","785":"023b473e","808":"7b03ad96"}[chunkId] + ".chunk.js";
};